import capitalize from 'lodash/capitalize';
import qs from 'qs';
import React, { Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigProvider } from 'tdesign-react';
import AegisV2 from '@tencent/aegis-web-sdk-v2';
import { ErrorBoundary } from '@tencent/semi-ui';
import { getTDesignLocale } from 'common/locales/tdesign';
import JSRuntime from 'common/utils/JSRuntime';
import { VendorApi } from 'idpBase/api';
import { convert, useStore } from 'idpBase/store';
import RouteEntry from './RouteEntry';

const RootContainer = () => {
  const { rootStore } = useStore();
  const { pathname, hash } = window.location;
  const query = JSRuntime.parseLocationSearch(undefined, {
    transferNum: false,
  });
  const semiUiTranslation = useTranslation('semi-ui');

  const appType = _.get(query, 'appType') || '';

  useEffect(() => {
    const onPushStateChange = () => {
      rootStore.updateDataReportUrl();
    };
    window.addEventListener('pushState', onPushStateChange);
    window.addEventListener('replaceState', onPushStateChange);

    return () => {
      rootStore.resetStore();
      window.removeEventListener('pushState', onPushStateChange);
      window.removeEventListener('replaceState', onPushStateChange);
    };
  }, []);

  useEffect(() => {
    if (appType && appType !== rootStore.externalAppType) {
      rootStore.getExternalAppInfo(appType).then((res) => {
        // 如果有第三方应用 /?appType=xxx, 则将其解析出的 oauth 地址作为 redirectUrl，其余部分流程与 sp 发起登录一致
        const redirectUri = _.get(res, 'redirectUri');
        if (!redirectUri) return;
        const redirectUrl = VendorApi.getAuthorizeUrl(
          qs.stringify({
            client_id: _.get(res, 'id'),
            response_type: 'code',
            redirect_uri: redirectUri,
            inaccessible_url: JSRuntime.getIdpSite('', 'app_authorization/fail'),
          }),
        );
        const nextSearch = qs.stringify({ ...query, redirectUrl });
        window.history.replaceState(
          { appType },
          document.title,
          `${pathname}?${nextSearch}${hash}`,
        );
      });
    }
  }, [appType]);

  const globalConfig = {
    ...getTDesignLocale(),
    form: { requiredMark: false },
    lang: semiUiTranslation.i18n.language,
    i18n: semiUiTranslation,
  };
  // 首字母大写
  if (globalConfig.select) {
    globalConfig.select.placeholder = capitalize(globalConfig.select.placeholder);
  }
  if (globalConfig.input) {
    globalConfig.input.placeholder = capitalize(globalConfig.input.placeholder);
  }

  return (
    <ConfigProvider globalConfig={globalConfig}>
      <ErrorBoundary
        onError={(data) => {
          window.aegis?.report({
            type: 'normal',
            level: AegisV2.logLevel.ERROR,
            msg: data,
          });
        }}
      >
        <Suspense>
          <RouteEntry />
        </Suspense>
      </ErrorBoundary>
    </ConfigProvider>
  );
};

export default convert(RootContainer);
